
import classNames from "classnames";
import { Headline } from "src/UI";
import st from "./WaitBlock.module.scss";

interface IWaitBlockProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
	/** Тип блока */
	type?: "short" | "full";
	/** Заголовок блока */
    title?: string
	/** Подзаголовок блока */
	subTitle?: string;
	/** Положение блока */
	center?: boolean;

};

/** Компонента блока действия */
const WaitBlock: React.FC<IWaitBlockProps> = ( { type = "full", title = "Загрузка данных", subTitle = "Пожалуйста, подождите...", center = false, className, ...otherProps } ) => (
    <div id="rdc_saveprocessing" className={classNames(st.waiting_block, className, { [st.center]: center })} {...otherProps}>
		<div className={classNames(st.waiting_block__spiner, "rdc_spiner")} />
		<div className={st.waiting_block__texts}>
			<Headline type="large" className="centered">{title}</Headline>
			{ type === "full" && <Headline type="small" className="centered">{subTitle}</Headline> }
		</div>
	</div>
);

export default WaitBlock;
